// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "toyota-bold";
  src: url("/fonts/ToyotaType-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-book";
  src: url("/fonts/ToyotaType-Book.ttf") format("truetype");
}
@font-face {
  font-family: "toyota-regular";
  src: url("/fonts/ToyotaType-Regular.ttf") format("truetype");
}
.data-consents {
  width: 100%;
}
.data-consents .title {
  font-family: "toyota-bold";
  font-size: 20px;
  line-height: 28px;
  margin: 16px 0;
  text-transform: none;
  color: #cc0000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.data-consents .title .close-btn {
  background: #cc0000;
  color: #fff;
  font-family: "toyota-bold";
  border: none;
  border-radius: 6px;
  padding: 8px 20px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 100%;
  float: none;
}
.data-consents .consent-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.data-consents .consent-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 26px;
}
.data-consents .consent-toggle {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.data-consents .consent-label {
  font-family: "toyota-regular";
  font-size: 16px;
  line-height: 26px;
  color: #222222;
}
.data-consents .status-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.data-consents .status-icon.ok {
  color: #31b057;
}
.data-consents .status-icon.not-ok {
  color: #cc0000;
}
.data-consents .status-icon.unknown {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  background: #979797;
  border-radius: 50%;
  flex: 0 0 20px;
}
.data-consents .status-icon.unknown::after {
  content: "";
  position: absolute;
  inset: 4px;
  background: #979797;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.data-consents .consent-legend {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  align-self: stretch;
  margin-bottom: 16px;
}
.data-consents .legend-items {
  display: flex;
  align-items: center;
  gap: 24px;
}
.data-consents .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.data-consents .legend-text {
  font-family: "toyota-bold";
  font-size: 14px;
  line-height: 20px;
  color: #222222;
}
.data-consents .legend-help-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.data-consents .legend-help {
  margin: 0;
  font-family: "toyota-bold";
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #222222;
  flex: 1;
}

::ng-deep .mat-mdc-tooltip {
  font-size: 14px !important;
}

:host ::ng-deep .data-consents .consent-legend {
  width: 100% !important;
  max-width: none !important;
}

.data-consent__empty {
  padding: 16px;
  font-size: 14px;
  color: rgb(0, 0, 0);
}

.info_tooltip {
  cursor: pointer;
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.consent-label-wrapper {
  display: inline-flex;
  align-items: center;
  flex: 1;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/fonts/toyota-fonts.scss","webpack://./src/app/admin/subscription/data-consent/data-consent.component.scss","webpack://./src/app/styles/colors/palette.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,yDAAA;ACCF;ADCA;EACE,0BAAA;EACA,yDAAA;ACCF;ADCA;EACE,6BAAA;EACA,4DAAA;ACCF;AARA;EACE,WAAA;AAUF;AARE;EACE,0BDYG;ECXH,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;AASJ;AAPI;EACE,mBAAA;EACA,WAAA;EACA,0BDFC;ECGD,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;AASN;AALE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAOJ;AAJE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAMJ;AAHE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAKJ;AAFE;EACE,6BDtCM;ECuCN,eAAA;EACA,iBAAA;EACA,cAAA;AAIJ;AADE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAGJ;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;AACE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAEE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAHJ;AAME;EACE,0BDrGG;ECsGH,eAAA;EACA,iBAAA;EACA,cAAA;AAJJ;AAOE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AALJ;AAQE;EACE,SAAA;EACA,0BDnHG;ECoHH,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,OAAA;AANJ;;AAUA;EACE,0BAAA;AAPF;;AAUA;EACE,sBAAA;EACA,0BAAA;AAPF;;AAUA;EACE,aAAA;EACA,eAAA;EACA,mBC3GM;ADoGR;;AAUA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;AAPF","sourcesContent":["@font-face {\n  font-family: 'toyota-bold';\n  src: url('/fonts/ToyotaType-Bold.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-book';\n  src: url('/fonts/ToyotaType-Book.ttf') format('truetype')\n}\n@font-face {\n  font-family: 'toyota-regular';\n  src: url('/fonts/ToyotaType-Regular.ttf') format('truetype')\n}\n// Book families\n$book: 'toyota-book';\n\n// Regular families\n$regular: 'toyota-regular';\n\n// Bold families\n$bold: 'toyota-bold';\n","@import \"../../../../app/styles/fonts/toyota-fonts.scss\";\n@import \"../../../../app/styles/colors/font_color_variables.scss\";\n\n.data-consents {\n  width: 100%;\n\n  .title {\n    font-family: $bold;\n    font-size: 20px;\n    line-height: 28px;\n    margin: 16px 0;\n    text-transform: none;\n    color: #cc0000;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .close-btn {\n      background: #cc0000;\n      color: #fff;\n      font-family: $bold;\n      border: none;\n      border-radius: 6px;\n      padding: 8px 20px;\n      cursor: pointer;\n      text-transform: uppercase;\n      letter-spacing: 0.3px;\n      line-height: 100%;\n      float: none;\n    }\n  }\n\n  .consent-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .consent-row {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 26px;\n  }\n\n  .consent-toggle {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .consent-label {\n    font-family: $regular;\n    font-size: 16px;\n    line-height: 26px;\n    color: #222222;\n  }\n\n  .status-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n\n  .status-icon.ok {\n    color: #31b057;\n  }\n  .status-icon.not-ok {\n    color: #cc0000;\n  }\n\n  .status-icon.unknown {\n    display: inline-block;\n    position: relative;\n    width: 20px;\n    height: 20px;\n    background: #979797;\n    border-radius: 50%;\n    flex: 0 0 20px;\n  }\n\n  .status-icon.unknown::after {\n    content: \"\";\n    position: absolute;\n    inset: 4px;\n    background: #979797;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n  }\n\n  .consent-legend {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100% !important;\n    max-width: none !important;\n    box-sizing: border-box;\n    padding: 16px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #ffffff;\n    align-self: stretch;\n    margin-bottom: 16px;\n  }\n\n  .legend-items {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n  }\n\n  .legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .legend-text {\n    font-family: $bold;\n    font-size: 14px;\n    line-height: 20px;\n    color: #222222;\n  }\n\n  .legend-help-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .legend-help {\n    margin: 0;\n    font-family: $bold;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 20px;\n    color: #222222;\n    flex: 1;\n  }\n}\n\n::ng-deep .mat-mdc-tooltip {\n  font-size: 14px !important;\n}\n\n:host ::ng-deep .data-consents .consent-legend {\n  width: 100% !important;\n  max-width: none !important;\n}\n\n.data-consent__empty {\n  padding: 16px;\n  font-size: 14px;\n  color: $black;\n}\n\n.info_tooltip {\n  cursor: pointer;\n  flex-shrink: 0;\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n\n.consent-label-wrapper {\n  display: inline-flex;\n  align-items: center;\n  flex: 1;\n  gap: 4px; \n}\n","//white\n$white: rgb(255, 255, 255);\n$dull_white: rgb(250, 250, 250);\n$white_2:rgb(242, 242, 242);\n\n// Grey Colors\n$grey: rgb(118, 118, 118);\n$dark_grey:rgb(33, 33, 33);\n$charcoal_gray: rgb(49, 56, 58);\n$content_grey: rgb(41, 45, 48);\n$dark_grey_2: rgb(34, 34, 34);\n$light_grey1: rgba(248, 248, 248, 0.8);\n$light_grey: rgba(0, 0, 0, 0.1);\n$light_grey2: rgba(0, 0, 0, 0.2);\n$light_grey3: rgb(176, 173, 171);\n$light_grey4: rgb(238, 238, 238);\n$charcoal_gray_transparency: rgba(49, 56, 58, 0.1);\n$black_grey:rgb(33, 13, 13);\n$text_grey:rgb(138, 138, 138);\n$warm_grey:rgb(155, 155, 155);\n$light_grey5: rgb(222, 222, 222);\n$light_grey6: rgb(181, 181, 181);\n$light_grey7: rgb(197, 192, 192);\n$light_grey8:rgb(226, 222, 222);\n$light_grey9:rgb(205, 189, 189);\n$light_grey11:rgb(216, 216, 216);\n$light_grey12:rgb(240, 240, 240);\n$light_grey13:rgb(182,182,182);\n$bg_grey:rgb(245, 245, 246);\n$light_shade_grey:rgb(170,170,170);\n$light_grey_3: rgb(207,207,207);\n$light_grey10: rgb(165, 165, 165);\n$light_grey12: rgb(242, 242, 242);\n$light_grey13: rgb(217, 217, 217);\n// Red Colors\n$toyota_red: rgb(180, 57, 53);\n$red: rgb(255, 5, 0);\n$toyota_red_light: rgba(180, 57, 53, 0.4);\n$red_transparency: rgba(255, 0, 0, 0.1);\n$red_transparency2: rgba(255, 0, 0, 0.2);\n$dark_red:rgb(217, 37, 42);\n$customer_invalid_red: rgb(255, 5, 0);\n$session_timeout_red: rgb(235, 10, 30);\n$status_red: rgb(204, 0, 0);\n$banner_red:rgb(200,0,0);\n// orange\n$orange: rgb(249, 130, 5);\n// black\n$black: rgb(0, 0, 0);\n$black_grey:rgb(74, 74, 74); \t\n$black_grey2:rgb(41, 45, 48);\n// Green\n$dark_green:rgb(48, 120, 58);\n$green: rgb(26, 151, 105);\n$medium_green:rgb(57, 181, 74);\n$green_transparency2: rgba(26, 151, 105, 0.3);\n$light_green: rgba(39, 170, 122, 0.2);\n// Yellow\n$non-telematics-yellow: rgba(255, 212, 0, 1);\n$yellow: rgb(255,255,0);\n//pink\n$pink:rgb(253, 230, 232);\n// Opacities and compositions\n$black-transparency: rgba($black, 0.87);\n$grey_transparency: rgba(0, 0, 0, 0.5);\n$transparent: rgba(0, 0, 0, 0);\n$edit_icon_color: rgb(11, 100, 255);\n$cornflower_blue: rgb(100, 149, 237);\n$blue: rgba(0, 126, 255, 1);\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
